<div class="modal-container">
  <button
    id="modalParametrizacion"
    #modalParametrizacion
    data-bs-toggle="modal"
    data-bs-target="#modalParametrizacionForm"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalParametrizacionForm"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ 'parametrizacion.editar_parametrizacion' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formulario" (ngSubmit)="onGuardar()">
            <div class="mb-4">
              <label for="nombre" class="form-label">
                {{ 'parametrizacion.nombre' | translate }} :
              </label>
              <input
                id="nombre"
                [disabled]="true"
                class="form-control"
                formControlName="nombre" />
            </div>
            <div class="mb-4">
              <label for="descripcion" class="form-label">
                {{ 'parametrizacion.descripcion' | translate }} :
              </label>
              <input
                id="descripcion"
                class="form-control"
                formControlName="descripcion"
                [disabled]="true" />
            </div>
            <div class="mb-4">
              <label for="valor" class="form-label">
                {{ 'parametrizacion.valor' | translate }} :
              </label>
              <input id="valor" class="form-control" formControlName="valor" />
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                data-bs-dismiss="modal"
                [disabled]="formulario.invalid"
                class="btn btn-govco fill-btn-govco my-2"
                aria-label="Guardar">
                {{ 'parametrizacion.guardar' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-govco outline-btn-govco my-2"
                data-bs-dismiss="modal"
                aria-label="Cancelar">
                {{ 'parametrizacion.cancelar' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
